declare var angular: any;
import { flatten } from 'lodash';
import * as _ from 'underscore';
import { Choices } from '../../../../../../../../../../libs/models/src';

angular
  .module('UserTrainingControllers')

  .service('trainingUtils', [
    '$location',
    'exam',
    '$filter',
    '$mdDialog',
    'audio',
    'api',
    '$mdToast',
    'EXAM',
    '$sce',
    function(
      $location,
      exam,
      $filter,
      $mdDialog,
      audio,
      api,
      $mdToast,
      EXAM,
      $sce
    ) {
      this.getOptions = function() {
        var option = {
          lesson: false,
          part: [],
          buildup: false,
          support: null
        };

        option = _.extend(option, $location.search());
        if (option.part && !option.part.join) {
          option.part = [option.part];
        }
        console.log('🔥', option);

        return option;
      };

      var self = this;
      this.getSupport = function(option) {
        if (!option) {
          option = self.getOptions();
        }

        var promise;
        if (option.support) {
          promise = api.getSupport(option.support);
        } else if (option.lesson) {
          promise = api.getSupportByLesson(option.lesson);
        } else if (option.part && option.part.length) {
          promise = api.getSupportByParts(option.part, option.buildup);
        } else {
          promise = api.getSupport();
        }

        return promise.then(function(data) {
          data.support.questions = _.sortBy(
            data.support.questions,
            (question: any) => question.id
          );

          if (!option.lesson) {
            data.score = null;
          }
          return data;
        });
      };

      this.getSupports = function(part, n, buildup) {
        var promise = api.getSupports(part, n, buildup);
        return promise.then(function(data) {
          return data.supports.map(function(support) {
            support.questions = _.sortBy(
              support.questions,
              (question: any) => question.id
            );
            return support;
          });
        });
      };

      this.addTimerToSupports = function(supports) {
        return supports.map(function(support) {
          var part = exam.getPartById(support.part);
          if (part.timer) {
            return _.extend(support, { timer: part.timer });
          }
          return support;
        });
      };

      this.loadAudioSupport = function(support) {
        audio.loadOneTrack(
          audio.convertToTrack(support.id, support.training_audio)
        );
      };

      // detect if support is finished
      this.checkFinishedSupport = function(support) {
        for (var j = 0; j < support.questions.length; j++) {
          if (!support.questions[j].choice_user) return false;
        }
        return true;
      };

      this.sendSupportAnswers = async function(
        support,
        openGappedAnswers = {}
      ): Promise<any> {
        return Promise.all(
          support.questions.map(question => {
            if (question.choice_user) {
              return api.saveAnswer(
                question.choice_user,
                false,
                openGappedAnswers[question.id]
              ); // mock=false
            } else {
              return Promise.resolve(null);
            }
          })
        );
      };

      // give feedback for answers with color
      // update results progress bar
      this.correctAnswers = function(support, results) {
        var nbGoodAnswsers = 0;
        // special case for Le Robert support because sometime, there are multiple questions but only one good answer
        var nbTotalGoodAnswersOnSupport = flatten(
          support.questions.map(q => q.choices)
        ).filter((choice: Choices) => choice.is_correct).length;

        angular.forEach(support.questions, function(question) {
          angular.forEach(question.choices, function(choice) {
            let partFromExamData = exam.getPartById(support.part);
            console.log('partFromExamData', partFromExamData);

            if (choice.is_correct) {
              choice.goodAnswer = true;

              if (
                EXAM !== 'delf' ||
                (EXAM === 'delf' &&
                  !(
                    partFromExamData?.score === 'oral_score' ||
                    partFromExamData?.score === 'writing_score'
                  ))
              ) {
                if (results && question.choice_user == choice.id) {
                  results.goodAnswers++;
                  nbGoodAnswsers++;
                }
              }
            } else {
              if (choice.id == question.choice_user) {
                choice.badAnswer = true;
                if (
                  EXAM !== 'delf' ||
                  (EXAM === 'delf' &&
                    !(
                      partFromExamData?.score === 'oral_score' ||
                      partFromExamData?.score === 'writing_score'
                    ))
                ) {
                  // TODO never bad answers
                  if (results) results.badAnswers++;
                }
              }
            }
          });
        });
        support.nbGoodAnswer = nbGoodAnswsers;
        support.nbTotalGoodAnswersOnSupport = nbTotalGoodAnswersOnSupport;
      };

      this.normalizeString = function(str) {
        return (
          str
            // oe -> œ
            .replace(/œ/gm, 'oe')
            .replace(/ +/gm, ' ')
            .replace(/’/gm, "'")
            .replace(/\./gm, '')
            .trim()
            .toLowerCase()
        );
      };

      this.checkedOpenGapAnswer = (question, userInput: string) => {
        console.log('questions', question, userInput);
        let userInputNormized = this.normalizeString(userInput);

        let findedChoice = _.find(question.choices, (choice: any) => {
          let correctChoices = (choice?.text as string)
            ?.split('/')
            .map(c => this.normalizeString(c));

          console.log('Exercise', correctChoices, userInputNormized);
          return correctChoices?.includes(userInputNormized);
        });

        if (!findedChoice) {
          let badChoice = _.find(
            question.choices,
            (choice: any) => choice.is_correct === false
          );
          if (badChoice) {
            question.choice_user = (badChoice as any).id;
          } else {
            question.choice_user = null;
          }
          console.log('bad', badChoice);
        } else {
          question.choice_user = (findedChoice as any).id;
        }
        console.log('findedChoice', findedChoice);
      };

      this.lessonsToastDisplay = function(titleLesson, success) {
        $mdToast.show({
          locals: {
            titleLesson: titleLesson,
            success: success
          },
          controller: [
            '$scope',
            'titleLesson',
            'success',
            function($scope, titleLesson, success) {
              $scope.titleLesson = titleLesson;
              $scope.success = success;
            }
          ],
          position: 'top right',
          hideDelay: 12000,
          templateUrl:
            '/ng1/www/modules/user/practice/training/html/toast_lessons.html'
        });
      };

      this.partHelp = function(part, ev) {
        let title = exam.examData.langForExercises === 'en' ? 'Part' : 'Module';

        $mdDialog.show(
          $mdDialog
            .alert({
              preserveScope: true,
              parent: angular.element(document.body)
            })
            .parent(angular.element(document.body))
            .title(title + ' ' + part + ' : ' + $filter('partToString')(part))
            .textContent(exam.getPartById(part).directionText)
            .ariaLabel('Help support')
            .ok('Fermer')
            .targetEvent(ev)
            .clickOutsideToClose(true)
        );
      };
    }
  ]);
